import Formatters from "@/utils/Formatters";
import {compareStr} from "@/utils/compareStrings";

export const captacaoFillsMixin = {
  methods: {
    fillCaptationForm(item) { 
      if (!item.id) return;

      if (parseInt(item.donor_id) != parseInt(this.resource.id)) return;

      const realizedSlug = this.typeSurgery.find(type => type.id == parseInt(item.type_captation_id))?.slug;
      const hasSurgeryData = !!(item.start_surgery || item.aortic_clamping || item.perfusion_time || item.end_surgery);
      const hasReasonData = !!item.reason_not_captured_id;

      if (hasSurgeryData || hasReasonData) {
        this.realized = realizedSlug || null;

        if (hasSurgeryData) {
          this.captationsForm.start_surgery = item.start_surgery || "";
          this.captationsForm.aortic_clamping = item.aortic_clamping || "";
          this.captationsForm.perfusion_time = item.perfusion_time || "";
          this.captationsForm.end_surgery = item.end_surgery || "";
        }

        if (hasReasonData) {
          this.captationsForm.reason_not_captured_id = parseInt(item.reason_not_captured_id);
          this.captationsForm.reason_not_captured = item.reason_not_captured;

          const reason = this.reason_captations.find(r => r.id == this.captationsForm.reason_not_captured_id);
          this.isFamilyReason = reason ? compareStr(reason.description, "desistenciafamiliar") : false;
          this.captationsForm.reasonsForNotCaptureId = reason ? reason.description : null;
        }
        return;
      }

      this.realized = null;
    },

    fillOrgonsForm(item) {
      if (parseInt(item.donor_id) != parseInt(this.resource.id)) return;

      this.fillBloodCollection(item);
      this.fillFabricConditioning(item);
      this.fillTemperatureControl(item);
      this.fillOrgans(item);
    },

    fillBloodCollection(item) {
      if (!item.blood_collection_captations || !item.blood_collection_captations.length) return;
      const blood = item.blood_collection_captations[0];
      this.bloodCollection.blood_sample_collection_id = parseInt(blood.blood_sample_collection_id);
      this.bloodCollection.description = blood.description;
      this.bloodCollection.needle_gauge = blood.needle_gauge;
    },

    fillFabricConditioning(item) {
      if (!item.fabric_conditioning || !item.fabric_conditioning.length) return;
      this.selectedFabricConditionings = item.fabric_conditioning.map(i => parseInt(i.id));
    },

    fillTemperatureControl(item) {
      if (!item.temperature_controls || !item.temperature_controls.length) return;
      const temperature = item.temperature_controls[0];
      this.fabric_conditioning.current_temperature_saida = temperature.current_temperature;
      this.fabric_conditioning.temperature_date_and_time_saida = temperature.temperature_date_and_time
        ? temperature.temperature_date_and_time.slice(0, 16)
        : "";
    },

    fillOrgans(item) {
      if (!item.orgons_captured || !item.orgons_captured.length) return;

      const orgonsCaptured = item.orgons_captured;
      for (const orgon of orgonsCaptured) { 
        orgon.orgon_captured_status_id = this.setIdToSlug(orgon);
        orgon.name = orgon.orgon.name;
        orgon.reason_not_captured_id = orgon.reason_not_captured_id ? parseInt(orgon.reason_not_captured_id) : null;
        orgon.preservation_solutions_id = orgon.preservation_solutions_id ? parseInt(orgon.preservation_solutions_id) : null;
        orgon.lot_expiration_date = orgon.lot_expiration_date ? Formatters.dataAtualFormatada(orgon.lot_expiration_date) : null;

        const optionFive = orgon.surgical_description ? orgon.surgical_description.find(x => x.id == 5) : undefined;
        orgon.intercorrency = optionFive ? "1" : "2";

        if (orgon.nephrectomy && orgon.nephrectomy.length) {
          const neph = orgon.nephrectomy[0];
          orgon.normal_morphology = neph.normal_morphology;
          orgon.single_arterial_pedicle = neph.single_arterial_pedicle;
          orgon.single_venous_pedicle = neph.single_venous_pedicle;
          orgon.single_ureteral_rout = neph.single_ureteral_rout;
          orgon.adequate_perfusion = neph.adequate_perfusion;
        }
      }

      this.orgons = orgonsCaptured;
    },

    setIdToSlug(orgon) {
      switch (true) {
        case orgon.em_bloco_flg == 'SIM':
          return 'captado-em-bloco';
        case orgon.orgon_captured_status.id == 1:
          return 'captado';
        case orgon.orgon_captured_status.id == 2:
          return 'nao-captado';
        default:
          return null;
      }
    },
  },
};
